export default "__VITE_ASSET__121d0265__"